<template>
    <div>
        <div class="hero bg-light">
            <TDSHead/>
            <div class="container py-5 py-md-10 text-center">
                <div class="row d-lg-flex align-items-center">
                    <div class="col-lg-4">
                        <h1 class="font-family-sans-serif text-secondary m-0 h4" style="letter-spacing: 1px;">{{$t('404.error')}}</h1>
                        <h2 class="font-family-sans-serif display-4 text-orange font-weight-bold" style="line-height: 100%;">{{$t('404.title')}}</h2>
                        <p class="mb-4 h4 font-family-sans-serif">{{$t('404.description')}}</p>
                        <a class="btn btn-primary mb-4" href="/">{{$t('404.cta')}}</a>
                    </div>
                     <div class="col-lg-7 offset-lg-1">
                        <img src="../assets/img/404.jpg" class="img-fluid rounded">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BaseVue from "./BaseVue"
    export default {
        extends: BaseVue,
        name: '404',
        metaInfo() {
            return {
                title: ('404 - TDS.sport'),
            }
        }
    }
</script>
